import { LocalParticipant, Room } from 'twilio-video';
import { useEffect } from 'react';

export function stopLocalParticipant(local: LocalParticipant) {
  console.log('Disconnecting Twilio');
  [...local.videoTracks.values(), ...local.audioTracks.values()].forEach((publication) => {
    publication.track.stop();
    publication.unpublish();
  });
}

export function useStopTwilioOnUnmount(room?: Room) {
  const p = room?.localParticipant;

  useEffect(() => {
    return () => {
      if (!p) return;

      stopLocalParticipant(p);
    };
  }, [p]);
}
